const s = {
  name: "UserPencil",
  dimensions: { width: 37, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 37.2 40" style="enable-background:new 0 0 37.2 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M10,8c0-4.4,3.6-8,8-8s8,3.6,8,8c0,4.4-3.6,8-8,8S10,12.4,10,8z M18,2c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6
			S21.3,2,18,2z"/>
		<path class="st0" d="M0,29c0-6.1,4.9-11,11-11h15v2H11c-5,0-9,4-9,9v11H0V29z"/>
		<path class="st0" d="M6,30v10h2V30H6z"/>
		<path class="st0" d="M29.9,20.7c1.2-1.2,3.1-1.2,4.2,0l2.2,2.2c1.2,1.2,1.2,3.1,0,4.2L23.4,40H17v-6.4L29.9,20.7z M32.7,22.1
			c-0.4-0.4-1-0.4-1.4,0L29.4,24l3.6,3.6l1.9-1.9c0.4-0.4,0.4-1,0-1.4L32.7,22.1z M31.6,29L28,25.4l-9,9V38h3.6L31.6,29z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as UserPencil
};
